// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  text: 'Conclude',
  label: 'Finish setup and close this form',
} as ILanguage;
